module.exports = __webpack_public_path__ + "static/media/course1.8d7c0630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course1.png
// module id = 2843
// module chunks = 0